'use es6';

import RequestStatus from 'pricing-pages-unified-ui/constants/RequestStatus';
export const requestsSelector = ({
  requests
}) => requests;
export const makeRequestStatusSelector = requestType => state => {
  const requestStatuses = requestsSelector(state);
  return requestStatuses[requestType] || RequestStatus.UNINITIALIZED;
};